import { KeycloakService } from "keycloak-angular";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private readonly keycloakService: KeycloakService) { }

  getUsername() {
    return this.keycloakService.getUsername();
  }

  async getProfile(): Promise<any> {
    try {
      if (this.isLoggedIn()) {
        const profile = await this.keycloakService.loadUserProfile();
        return profile;
      }
      return null;
    } catch (error) {
      console.error("Error fetching user information:", error);
      throw error;
    }
  }

  logout() {
    this.keycloakService.logout();
  }

  isLoggedIn(): boolean {
    return this.keycloakService.isLoggedIn();
  }

  accountManagement(): Promise<void> {
    return this.keycloakService.getKeycloakInstance().accountManagement();
  }

  getUserRoles(): string[] {
    return this.keycloakService.getUserRoles();
  }

  getUserGroups(): string[] {
    const tokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    if (tokenParsed) {
      return tokenParsed["groups"] || [];
    }
    return [];
  }

  hasRole(role: string): boolean {
    return this.getUserRoles().indexOf(role) > -1;
  }

  getCompanyId(): string | undefined {
    const tokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    return tokenParsed?.["companyId"];
  }

  isUserAuthorizedByGroup(groupName: any): boolean {
    const userGroups = this.getUserGroups();
    if (groupName) {
      return userGroups.some((group) => group.includes(groupName));
    }
    return false;
  }
}
